/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updatePasswordBodyUserPasswordMin = 12;

export const UpdatePasswordBody = zod
	.object({
		current_password: zod.string().describe('Current password'),
		user: zod.object({
			password: zod
				.string()
				.min(updatePasswordBodyUserPasswordMin)
				.optional()
				.describe('New password'),
			password_confirmation: zod.string().optional().describe('Password confirmation')
		})
	})
	.describe('Update password request body');

export type UpdatePasswordBody = zod.input<typeof UpdatePasswordBody>;
export type UpdatePasswordBodyOutput = zod.output<typeof UpdatePasswordBody>;
